export default __webpack_public_path__ + "static/media/banner_gold.e471b572.png";